var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.3906 27.27L82.0156 34.9711V19.0625C82.0156 14.8909 78.6247 11.5 74.4531 11.5H9.125C4.95345 11.5 1.5625 14.8909 1.5625 19.0625V82.625C1.5625 86.7966 4.95345 90.1875 9.125 90.1875H74.4531C78.6247 90.1875 82.0156 86.7966 82.0156 82.625V66.7164L95.3906 74.4175C98.073 75.9664 101.438 74.029 101.438 70.9388V30.7598C101.438 27.6599 98.0741 25.7204 95.3906 27.27ZM73.0703 81.2422H10.5078V20.4453H73.0703V81.2422ZM82.0135 45.2478L94.2508 36.7894V64.9481L81.9141 57.2155L82.0135 45.2478ZM17.9531 34.5703H30.3125C31.0742 34.5703 31.6953 33.9492 31.6953 33.1875V27.8906C31.6953 27.1289 31.0742 26.5078 30.3125 26.5078H17.9531C17.1914 26.5078 16.5703 27.1289 16.5703 27.8906V33.1875C16.5703 33.9492 17.1914 34.5703 17.9531 34.5703Z",
    fill: "#404041",
    stroke: "#404041"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.a34fcaa1bc20e8a309c2dd783dc00fc5.svg";
export { ForwardRef as ReactComponent };